import { render, staticRenderFns } from "./refundDetail.vue?vue&type=template&id=45056fc5&scoped=true"
import script from "./refundDetail.vue?vue&type=script&lang=js"
export * from "./refundDetail.vue?vue&type=script&lang=js"
import style0 from "./refundDetail.vue?vue&type=style&index=0&id=45056fc5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45056fc5",
  null
  
)

export default component.exports